import React from 'react'
import { CircularProgress } from '@mui/material'
import Modal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'

interface HandleAPIFailuresProps {
  response: any
  title: string
  handleClose: () => void
}

const HandleAPIFailures = (props: HandleAPIFailuresProps): JSX.Element => {
  const title = 'Fetching ' + props.title
  const message = 'No ' + props.title + ' found'
  if (props.response.httpStatus === APIConfiguration.SUCCESS_HTTP_STATUS) {
    return (<></>)
  } else if (props.response.isLoading as boolean) {
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, background: 'rgba(0, 0, 0, 0.5)' }}>
        <div className='CircularprogressAmi' style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress />
        </div>
      </div>
    )
  } else if (props.response.httpStatus === APIConfiguration.BAD_REQUEST) {
    return (
      <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'}
        onClose={props.handleClose} title={title}>
        <div className='authError'>
            <AuthError className={'errorCompInsideModal'} customError='No Data Found' />
        </div>
      </Modal>
    )
  } else if (props.response.httpStatus === APIConfiguration.NO_DATA_FOUND_HTTP_STATUS) {
    return (
      <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'}
        onClose={props.handleClose} title={title}>
        <div className='authError'>
            <AuthError className={'errorCompInsideModal'} customError={message} />
        </div>
      </Modal>
    )
  } else {
    return (
      <Modal titleStyle={{ paddingRight: '2em' }} width={'fit-content'} height={'fit-content'}
        onClose={props.handleClose} title={title}>
        <div className='authError'>
            <AuthError className={'errorCompInsideModal'} customError={'Internal Server Error'} />
        </div>
      </Modal>
    )
  }
}

export default HandleAPIFailures
